import styled from "styled-components";

export const Container = styled.div`
	@media screen and (min-width: 0px) {
		flex: 1 1 auto;
		contain: content;
		display: flex;
		flex-direction: column;
	}

	@media screen and (min-width: 992px) {
		flex-direction: row-reverse;
		max-height: calc(100vh - 90px);
		overflow: hidden;

		main.layout {
			flex: 1 1 auto;
			overflow-y: auto;
		}

		aside#aside {
			height: calc(100vh - 90px);
		}
	}
`;
